<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">
  <div class="modal-header">
    <h4 class="modal-title">Remove Pricing Matrix</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p>
      <b>{{ matrix.name }}</b> will no longer be available to view or edit and may not be applied to any new events or schedules.
    </p>

    <p class="mb-0">
      Any existing events with this pricing matrix will continue to use it until they are moved to a new matrix.
    </p>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-danger"
            (click)="handleSubmit()"
            *ngIf="!loadingRemove">
      Remove
    </button>
    <button class="btn btn-danger disabled" type="button" disabled
            *ngIf="loadingRemove">
      Loading...
    </button>
  </div>
</ng-container>
